import { Dto } from '@core/data/dto/dto';
import { DTO_DEFAULT, DtoType } from '@core/data/dto/dto-types';
import { Entity } from '@core/data/dto/entity';
import { DtoExport, DtoImport } from '@core/utils/dto';
import { copyObjectProperties } from '@core/utils/object';
import { TipSourcesResponseSchema } from './tip-sources-response.schema';
import { TipSource } from './tip-source';

export class TipSourcesResponse implements Entity {
    public selected: string;
    public sources: TipSource[];

    constructor(value?: any) {
        if (value) {
            copyObjectProperties.call(this, value);
        }
    }

    @DtoImport(TipSourcesResponseSchema)
    static import(dto: Dto): any {
        return new TipSourcesResponse(dto);
    }

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: TipSourcesResponseSchema,
        },
    ])
    export(type?: DtoType): any {}
}
